(() => {
  const initialize = (root) => {
    const catalog = root.querySelector('[data-catalog]');
    if (!catalog || catalog.dataset.ready) return;
    catalog.dataset.ready = 'true';
    const dialog = catalog.querySelector('dialog');
    let opener;
    const close = () => dialog.close();
    const open = (handle, trigger) => {
      const template = Array.from(catalog.querySelectorAll('template[data-product]')).find(t => t.dataset.product === handle);
      if (!template || dialog.open) return false;
      opener = trigger;
      dialog.querySelector('[data-dialog-content]').replaceChildren(template.content.cloneNode(true));
      dialog.showModal();
      document.documentElement.classList.add('ps-dialog-open');
      const url = new URL(location.href); url.searchParams.set('product', handle); history.replaceState(null, '', url);
      return true;
    };
    const delegated = (event) => {
      const trigger = event.target.closest('[data-open-product]');
      if (trigger && open(trigger.dataset.openProduct, trigger)) event.preventDefault();
    };
    document.addEventListener('click', delegated);
    const initial = new URL(location.href).searchParams.get('product');
    if (initial) {
      const card = Array.from(catalog.querySelectorAll('[data-product-handle]')).find(item => item.dataset.productHandle === initial);
      if (card?.dataset.productUrl) {
        const destination = new URL(card.dataset.productUrl, location.origin);
        const current = new URL(location.href);
        for (const key of ['preview_theme_id', '_ab', '_fd', '_sc']) {
          if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
        }
        location.replace(destination.href);
      } else {
        open(initial, card?.querySelector('[data-open-product]'));
      }
    }
    catalog.addEventListener('click', event => {
      const filter = event.target.closest('[data-filter]');
      if (filter) {
        catalog.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === filter)));
        let count = 0;
        catalog.querySelectorAll('[data-family]').forEach(card => {
          card.hidden = filter.dataset.filter !== 'all' && card.dataset.family !== filter.dataset.filter && card.dataset.season !== filter.dataset.filter;
          if (!card.hidden) count++;
        });
        catalog.querySelector('[data-result-count]').textContent = count;
      }
      if (event.target.closest('[data-close-product]')) close();
      const thumb = event.target.closest('[data-photo]');
      if (thumb) {
        const main = dialog.querySelector('[data-gallery-main]');
        const photo = new URL(thumb.dataset.photo, location.origin);
        photo.searchParams.set('width', '1200');
        main.src = photo.href;
        main.alt = thumb.querySelector('img').alt;
        dialog.querySelectorAll('[data-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === thumb)));
      }
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) close(); });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('ps-dialog-open'); const url = new URL(location.href); url.searchParams.delete('product'); history.replaceState(null, '', url); opener?.focus({preventScroll: true}); });
    document.addEventListener('shopify:section:unload', event => { if(event.target.contains(catalog)){document.removeEventListener('click', delegated); document.documentElement.classList.remove('ps-dialog-open');} }, {once: true});
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.querySelectorAll('.ps-mobile-menu a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
})();
